<template>
  <section>
    <v-layout wrap class="hidden-sm-and-down">
      <v-flex md12 class="top-breadcrumbs">
        <v-container grid-list-md>
          <v-layout>
          <v-breadcrumbs :items="breadcrumbs" divider=" / "></v-breadcrumbs>
          </v-layout>
        </v-container>
      </v-flex>
    </v-layout>
    <v-container grid-list-md pt-12 mb-12>
      <v-layout wrap v-if="recruitments">
        <v-flex xs12 sm12 md6 lg6 pr-md-12 mb-md-12 text-left v-for="item in recruitments" :key="item.id">
          <div class="hr-h1">{{item.position}}</div>
          <div class="hr-h2">{{item.num}}人/{{item.update_time}}更新/</div>
          <div class="hr-label">职位描述</div>
          <div class="hr-p" v-html="item.position_desc">{{item.position_desc}}</div>
          <div class="hr-label">任职要求</div>
          <div class="hr-p" v-html="item.requirements">{{item.requirements}}</div>
        </v-flex>
        <v-flex xs12 sm12 md12 lg12 mt-12 class="hr-lx">
          <div>邮箱：infomaier@maier-kuechen.com</div>
          <div>联系人：王先生</div>
        </v-flex>
      </v-layout>
    </v-container>
  </section>
</template>
<script>
export default {
  data: () => ({
    recruitments: null,
    breadcrumbs: []
  }),
  created () {
    this.breadcrumbs = [
      { text: '关于玛娅', disabled: true },
      { text: '招贤纳士', disabled: true }
    ]
    this.getContact()
  },
  computed: {
    info () {
      return this.$store.getters.companyInfo
    }
  },
  methods: {
    getContact () {
      this.https.get('recruitment').then(response => {
        if (response.code === 0) {
          this.recruitments = response.data
        }
      })
    }
  }
}
</script>
<style lang="css">
  @import '../css/about.css';
</style>
